import React, { useState, useRef, useEffect } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  NumberInput,
  Text,
  Select,
  ActionIcon, 
  Stack,
} from "@mantine/core";
import { IconX, IconPlus } from "@tabler/icons-react";
import classes from "./add.module.css";
import { RowDataTerms } from "./types";

interface AddTermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddTerms: (newTermsData: RowDataTerms) => void;
}

const AddTermsModal: React.FC<AddTermsModalProps> = ({
  isOpen,
  onClose,
  onAddTerms,
}) => {
  const [newTerms, setNewTerms] = useState<RowDataTerms>({
    id: "",
    title: "",
    content: "",
    action: "Edit",
  });

  const [terms, setTerms] = useState<string[]>([])
  const [termInput, setTermInput] = useState<string>('')

  useEffect(()=>{
    setNewTerms({ ...newTerms, content: JSON.stringify(terms) })
  },[terms.length])

  const handleAddTerms = () => {
    // Check if any required fields are empty

    if(terms.length === 0){
        alert("Please fill in all the required fields");
        return;
    }

    if (!newTerms.title || !newTerms.content
    ) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddTerms(newTerms);

    // Clear inputs and reset state
    setNewTerms({
        id: "",
        title: "",
        content: "",
        action: "Edit",
    });
    setTerms([])
    setTermInput('')
    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewTerms({
        id: "",
        title: "",
        content: "",
        action: "Edit",
    });
    setTerms([])
    setTermInput('')
    // Call the onClose function
    onClose();
  };

    const addTerm = () => {
        if(termInput.trim().length < 1){
            alert("Please enter term");
            return;
        }
        terms.push(termInput.trim())
        setTermInput('')
    }

    const removeTerm = (index: number) => {
        setTerms(terms=> terms.filter((s,i)=>(i != index)))
    }

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          Create Terms & Condition
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
      size={'lg'}
    >
        

      <TextInput
        label="Title"
        placeholder="Input title"
        mb="sm"
        maxLength={255}
        value={newTerms.title}
        onChange={(event) =>
            setNewTerms({ ...newTerms, title: event.currentTarget.value })
        }
      />

        <Stack gap={4} mb="sm">
        {terms.length > 0 ? <Text className={classes.Text}>Terms & Conditions</Text> : null}
        {terms.map((item, i)=>(
            <div key={i} style={{display: 'flex', gap: 10, width: '100%'}}>
                <div style={{flex: 1}}>
                <TextInput
                    // disabled={createvenueMutation.isLoading}
                    value={item}
                    readOnly
                />
                </div>
                <ActionIcon onClick={() => removeTerm(i)} size='lg' variant="outline" color='red'>
                    <IconX size={20} />
                </ActionIcon>
            </div>
        ))
        }
        </Stack>
        

        <Text className={classes.Text}>Add Term</Text>
        <div style={{display: 'flex', gap: 10, width: '100%'}}>
            <div style={{flex: 1}}>
                <TextInput
                // label="Terms"
                placeholder="Input term"
                mb="sm"
                maxLength={255}
                value={termInput}
                onChange={(event) =>
                    setTermInput(event.currentTarget.value)
                }
                />
            </div>
            <ActionIcon onClick={() => addTerm()} size='lg' variant="outline" color='green'>
                <IconPlus size={20} />
            </ActionIcon>
        </div>

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddTerms} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddTermsModal;
